import {Component, OnInit} from '@angular/core';
import {NpsService} from "../../lib/services/nps/nps.service";
import {UserUtilsService} from "../../lib/services/user/user-utils.service";
import {AuthService} from "../../lib/services/auth/auth.service";

@Component({
    selector: 'app-nps-logout',
    templateUrl: './nps-logout.component.html',
    styleUrls: ['./nps-logout.component.scss']
})
export class NpsLogoutComponent implements OnInit{

    constructor(public npsService: NpsService,
                private userUtilsService: UserUtilsService,
                private auth: AuthService,) {
    }

    ngOnInit() {
        const userId = this.userUtilsService.getPersonId();
        this.npsService.getNps(userId)
    }

    closeSession(){
        this.auth.logOut();
    }

}
